export const MY_PROFILE_FETCH = "MY_PROFILE_FETCH"
export const MY_PROFILE_FETCHING = "MY_PROFILE_FETCHING"
export const MY_PROFILE_RECEIVED_AND_LOGGED_IN = "MY_PROFILE_RECEIVED_AND_LOGGED_IN"
export const MY_PROFILE_RECEIVED_AND_NOT_LOGGED_IN = "MY_PROFILE_RECEIVED_AND_NOT_LOGGED_IN"
export const MY_PROFILE_REQUEST_FAILED = "MY_PROFILE_REQUEST_FAILED"
